import { ContentCopy } from '@mui/icons-material';
import CustomModal from '../../modals';
import { DomainObject } from '../../../params/redux/domain';
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';

const DNSModal = ({ open, onClose, websiteDetails }: { open: boolean; onClose: () => void, websiteDetails: DomainObject | null }) => {
    const copyToClipboard = (text: string) => {
        if (text && text !== 'Not Available') {
            navigator.clipboard.writeText(text);
        }
    };

    const rows = [
        {
            host: websiteDetails?.domain_host_1 || 'Not Available',
            type: websiteDetails?.domain_type_1 || 'Not Available',
            record: websiteDetails?.domain_record_1 || 'Not Available'
        },
        {
            host: websiteDetails?.domain_host_2 || 'Not Available',
            type: websiteDetails?.domain_type_2 || 'Not Available',
            record: websiteDetails?.domain_record_2 || 'Not Available'
        },
        {
            host: websiteDetails?.domain_host_3 || 'Not Available',
            type: websiteDetails?.domain_type_3 || 'Not Available',
            record: websiteDetails?.domain_record_3 || 'Not Available'
        }
    ];

    return (
        <CustomModal open={open} handleClose={onClose} isBig={true} title="DNS Details">
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant="subtitle1" fontWeight="bold">Host</Typography></TableCell>
                            <TableCell><Typography variant="subtitle1" fontWeight="bold">Type</Typography></TableCell>
                            <TableCell><Typography variant="subtitle1" fontWeight="bold">Record</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                {/* Host Cell */}
                                <TableCell>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{row.host}</Typography>
                                        {row.host !== 'Not Available' && (
                                            <Tooltip title="Copy">
                                                <IconButton size="small" color="primary" onClick={() => copyToClipboard(row.host)}>
                                                    <ContentCopy fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Box>
                                </TableCell>

                                {/* Type Cell */}
                                <TableCell>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography variant="body2">{row.type}</Typography>
                                        {row.type !== 'Not Available' && (
                                            <Tooltip title="Copy">
                                                <IconButton size="small" color="primary" onClick={() => copyToClipboard(row.type)}>
                                                    <ContentCopy fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Box>
                                </TableCell>

                                {/* Record Cell */}
                                <TableCell>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>{row.record}</Typography>
                                        {row.record !== 'Not Available' && (
                                            <Tooltip title="Copy">
                                                <IconButton size="small" color="primary" onClick={() => copyToClipboard(row.record)}>
                                                    <ContentCopy fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Action Buttons */}
            <Box display="flex" gap={2} mt={2}>
                <Button variant="outlined" color="primary" onClick={onClose} fullWidth>
                    Close
                </Button>
            </Box>
        </CustomModal>
    );
};

export default DNSModal;
